export const parseNumericString = (str: string) => {
  return Number(
    str
      .trim()
      .replace(/[０-９]/g, (s) =>
        String.fromCharCode(s.charCodeAt(0) - 0xfee0)
      ) || NaN
  );
};
